import * as React from 'react';
import styled from 'styled-components';
import { Breadcrumbs, Divider, theme, Flex } from '@packages/ui';

import { CallToAction, CallToActionProps } from '../CallToAction/CallToAction';

const BreadcrumbsStyled = styled(Breadcrumbs)`
  margin: 0;
  padding: 0;
`;
export const CMSBreadcrumbs: React.FC<{ breadcrumbs?: CallToActionProps[]; customBreadcrumbs?: string }> = ({
  breadcrumbs,
  customBreadcrumbs,
}) => {
  if (!customBreadcrumbs && !breadcrumbs) {
    return null;
  }

  return (
    <Flex my={3} justifyContent={'center'}>
      {breadcrumbs &&
        breadcrumbs.map((breadcrumb: CallToActionProps, index: number) => (
          <Flex key={`breadcrumb-${index}`} alignItems="center">
            <CallToAction {...breadcrumb} fallbackAs="a">
              {/* todo: when calltoaction is refactored, this span can be removed */}
              <span>{breadcrumb.title}</span>
            </CallToAction>
            {index < breadcrumbs.length - 1 && <Divider color={theme.colors.anchorLinkColor} />}
          </Flex>
        ))}
      {customBreadcrumbs && (
        <Flex alignItems="center">
          {breadcrumbs?.length && <Divider color={theme.colors.anchorLinkColor} />}
          <BreadcrumbsStyled breadcrumbs={customBreadcrumbs} />
        </Flex>
      )}
    </Flex>
  );
};
